import { render, staticRenderFns } from "./ListChoiceRow.vue?vue&type=template&id=24ce743e&"
import script from "./ListChoiceRow.vue?vue&type=script&lang=js&"
export * from "./ListChoiceRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports